import { render, staticRenderFns } from "./VendorsSingle.vue?vue&type=template&id=32d6456d"
import script from "./VendorsSingle.vue?vue&type=script&lang=js"
export * from "./VendorsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports